import { render, staticRenderFns } from "./svipDetail.vue?vue&type=template&id=ce86418a&scoped=true"
import script from "./svipDetail.vue?vue&type=script&lang=js"
export * from "./svipDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce86418a",
  null
  
)

export default component.exports